export interface DateRange {
  from: Date;
  to: Date;
}

export function isDateRange(value: unknown): value is DateRange {
  return (
    typeof value === 'object' &&
    value !== null &&
    Object.hasOwn(value, 'from') &&
    Object.hasOwn(value, 'to')
  );
}

export type DateModifier = (date: Date | number) => Date;

interface ParseDateRangeOptions {
  modifier?: DateModifier;
}

export function parseDateRange(
  value: string[] | DateRange,
  {
    modifier = (date) => (typeof date === 'number' ? new Date(date) : date),
  }: ParseDateRangeOptions = {}
) {
  if (isDateRange(value)) {
    return { from: modifier(value.from), to: modifier(value.to) };
  }

  const from = Date.parse(value[0]);
  const to = Date.parse(value[1]);
  if (isNaN(from) || isNaN(to)) {
    return;
  }
  return { from: modifier(from), to: modifier(to) };
}

function isValidDate(date?: Date): date is Date {
  return date instanceof Date && !isNaN(date.getTime());
}

export function isValidDateRange(dateRange: DateRange): dateRange is DateRange {
  return isValidDate(dateRange?.from) && isValidDate(dateRange?.to);
}

export function isDateRangeEqual(
  dateRangeLeft: DateRange,
  dateRangeRight: DateRange
) {
  return (
    dateRangeLeft.from.getTime() === dateRangeRight.from.getTime() &&
    dateRangeLeft.to.getTime() === dateRangeRight.to.getTime()
  );
}
